import React from 'react'
import {Box, Typography} from '@mui/material'
import AppDialog from 'src/components-new/feedback/AppDialog'
import ReadOnlyField from 'src/components-new/inputs/ReadOnlyField'
import {familyTypes} from 'src/constants/constants'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface CaregiverDetailDialogNewProps {
  detail?: Record<string, any>
  open: boolean
  onClose: () => void
}

// Mappatura identica a `sexOptions` usata nel dialog legacy
// src/components/templates/CaregiverDetailDialog/CaregiverDetailDialog.tsx
const SEX_LABELS: Record<string, string> = {
  MALE: 'Maschio',
  FEMALE: 'Femmina',
  NOT_DECLARED: 'Non dichiarato'
}

const FIELD_GRID_SX = {
  display: 'grid',
  gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)'},
  gap: 2
} as const

const SECTION_TITLE_SX = {
  color: NEUTRAL_SCALE[900],
  fontWeight: 600,
  fontSize: 16,
  mb: 1
} as const

export default function CaregiverDetailDialogNew({detail, open, onClose}: CaregiverDetailDialogNewProps): JSX.Element {
  const address = detail?.address

  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title={[detail?.firstName, detail?.lastName].filter(Boolean).join(' ') || 'Caregiver'}
      maxWidth="md"
    >
      <Box sx={{display: 'flex', flexDirection: 'column', gap: 3}}>
        <Box>
          <Typography variant="h3" sx={SECTION_TITLE_SX}>Dati anagrafici</Typography>
          <Box sx={FIELD_GRID_SX}>
            <ReadOnlyField label="Cognome" value={detail?.lastName} />
            <ReadOnlyField label="Nome" value={detail?.firstName} />
            <ReadOnlyField
              label="Tipo delegato"
              value={detail?.caregiverType ? (familyTypes as Record<string, string>)[detail.caregiverType] ?? detail.caregiverType : undefined}
            />
            <ReadOnlyField label="Sesso" value={detail?.sex ? SEX_LABELS[detail.sex] ?? detail.sex : undefined} />
            <ReadOnlyField label="Nazionalità" value={detail?.nationality} />
          </Box>
        </Box>

        <Box>
          <Typography variant="h3" sx={SECTION_TITLE_SX}>Dati di contatto</Typography>
          <Box sx={FIELD_GRID_SX}>
            <ReadOnlyField label="Telefono" value={detail?.phoneNumber} />
            <ReadOnlyField label="Cellulare" value={detail?.cellPhoneNumber} />
            <ReadOnlyField label="Email" value={detail?.email} />
          </Box>
        </Box>

        <Box>
          <Typography variant="h3" sx={SECTION_TITLE_SX}>Indirizzo</Typography>
          <Box sx={FIELD_GRID_SX}>
            <ReadOnlyField label="Stato" value={address ? 'Italia' : undefined} />
            <ReadOnlyField label="Regione" value={address?.region} />
            <ReadOnlyField label="Provincia" value={address?.province} />
            <ReadOnlyField label="Città" value={address?.city} />
            <ReadOnlyField label="Indirizzo" value={address?.address} />
            <ReadOnlyField label="Civico" value={address?.streetNumber} />
            <ReadOnlyField label="Codice Postale" value={address?.postalCode} />
            <ReadOnlyField label="Località" value={address?.locality} />
          </Box>
        </Box>
      </Box>
    </AppDialog>
  )
}
